import { render, staticRenderFns } from "./NewsDetailForm.vue?vue&type=template&id=6de8f8ba&scoped=true"
import script from "./NewsDetailForm.vue?vue&type=script&lang=js"
export * from "./NewsDetailForm.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailForm.vue?vue&type=style&index=0&id=6de8f8ba&prod&lang=scss&scoped=true"
import style1 from "./NewsDetailForm.vue?vue&type=style&index=1&id=6de8f8ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de8f8ba",
  null
  
)

export default component.exports